import React, { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useInventoryEventDetailContext } from 'src/contexts/InventoryEventDetailContext/InventoryEventDetailContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import { SidePanelTab } from '../../../MarketListings/MarketListingHeader';
import { CompPricingSettings } from '../PricingSettings/CompPricingSettings';
import * as styles from './MapFooter.css';
import { SelectedListingMapStats } from './SelectedListingMapStats';

type MapFooterProps = {
  useVerticalView: boolean;
};

export const MapFooter: React.FC<MapFooterProps> = ({ useVerticalView }) => {
  const hasAutoPricingFeature = useUserHasFeature(Feature.AutoPricing);

  const { selectedListing, selectedGroup, selectedTab, compListings } =
    useInventoryEventDetailContext();
  const { loginContext } = useAppContext();

  const currencyCode = useMemo(() => {
    return (
      selectedListing?.currency ??
      loginContext?.user?.activeAccount.currencyCode ??
      null
    );
  }, [
    loginContext?.user?.activeAccount.currencyCode,
    selectedListing?.currency,
  ]);

  return (
    <div className={styles.footerContainer}>
      {(selectedListing || selectedGroup) &&
      hasAutoPricingFeature &&
      selectedTab == SidePanelTab.LISTINGS ? (
        <CompPricingSettings useVerticalView={useVerticalView} />
      ) : (
        <SelectedListingMapStats
          currencyCode={currencyCode}
          compListings={compListings}
        />
      )}
    </div>
  );
};
